<template>
    <div class="blackBg animate__animated animate__slideInLeft">
        <div class="cardTit">
            <span class="teamName">{{teamName?teamName:'XXX'}}</span>
        </div>
        <div class="main cardBg">
            <div class="contentBox">
                <p class="title">教练组：</p>
                <div>
                    <photoAndMsgCard v-for="item in coachList" style="text-align: left;float: left" width="5.6vw" height="6.5vw"
                                     :listData="item.list.length?item.list:[]"></photoAndMsgCard>
                </div>
                <p class="title">球员：<span
                        style="color: var(--primary-color)">{{teamReport.player ? teamReport.player.total : 0}}</span> 人</p>
                <div>
                    <div class="playerItem" v-for="item in playerPosition" :key="item.key">
                        <p class="label">{{item.label}}</p>
                        <p class="num" :style="{'color': item.color}">{{teamReport.player ? teamReport.player[item.key]
                            : 0}}</p>
                    </div>
                </div>
                <p class="title">伤病：<span style="color: #DE6969">{{teamReport.injuryTotal}}</span> 人</p>
                <div>
                    <photoAndMsgCard style="text-align: left" width="5.6vw" height="6.5vw"
                                     :listData="teamReport?teamReport.injuryPlayers:[]"></photoAndMsgCard>
                </div>
                <div style="margin-top: 2vw;margin-bottom: 1vw">
                    <div class="statistics" v-for="item in statistics" :key="item.key">
                        <span class="icon"><img :src="item.icon" alt=""></span>
                        <p class="label">{{item.label}}</p>
                        <p class="num"><span>{{teamReport[item.key] ? teamReport[item.key] : 0}}</span> {{item.unit}}
                        </p>
                    </div>
                </div>
                <div style="clear: both"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import photoCard from "../components/photoCard";
    import photoAndMsgCard from "../components/photoAndMsgCard";

    export default {
        name: "teamReport",
        components: {
            photoCard,
            photoAndMsgCard
        },
        computed: {
            teamId() {
                return this.$store.state.teamId;
            }
        },
        data() {
            return {
                teamName: this.$store.state.teamName ? this.$store.state.teamName.split('_')[0] : '',//梯队名称
                // teamId: this.$store.state.teamId,//梯队id
                teamReport: {},
                playerPosition: [
                    {key: 'forward', label: '前锋', color: '#42A5F5'},
                    {key: 'midfielder', label: '中场', color: '#65B168'},
                    {key: 'defender', label: '后卫', color: '#F95C51'},
                    {key: 'goalkeeper', label: '门将', color: '#FFC147'}
                ],
                statistics: [
                    {
                        key: 'trainingDays',
                        label: '训练天数：',
                        icon: require('@/assets/img/icon/trainingDays.svg'),
                        unit: '天'
                    },
                    {
                        key: 'trainingDuration',
                        label: '训练时长：',
                        icon: require('@/assets/img/icon/trainingDuration.svg'),
                        unit: '小时'
                    },
                    {
                        key: 'matches',
                        label: '比赛场次：',
                        icon: require('@/assets/img/icon/matches.svg'),
                        unit: '场'
                    },
                    {
                        key: 'trainingVideos',
                        label: '训练视频：',
                        icon: require('@/assets/img/icon/trainingVideos.svg'),
                        unit: '个'
                    },
                    {
                        key: 'playerEval',
                        label: '球员评估：',
                        icon: require('@/assets/img/icon/playerEval.svg'),
                        unit: '份'
                    },
                    {
                        key: 'gpsReports',
                        label: 'GPS报告：',
                        icon: require('@/assets/img/icon/gpsReports.svg'),
                        unit: '份'
                    },
                    {
                        key: 'exercises',
                        label: '训练教案：',
                        icon: require('@/assets/img/icon/exercises.svg'),
                        unit: '份'
                    },
                    {
                        key: 'physicalTests',
                        label: '体测报告：',
                        icon: require('@/assets/img/icon/physicalTests.svg'),
                        unit: '份'
                    },
                    {
                        key: 'questionnaires',
                        label: '球员自测：',
                        icon: require('@/assets/img/icon/questionnaires.svg'),
                        unit: '份'
                    }
                ],
                coachList: [
                    {
                        key: 'headCoach',
                        label: '主教练',
                        list: []
                    },
                    {
                        key: 'assistantCoach',
                        label: '助理教练',
                        list: []
                    },
                    {
                        key: 'techCoach',
                        label: '技术教练',
                        list: []
                    },
                    {
                        key: 'physCoach',
                        label: '运动表现教练',
                        list: []
                    },
                    {
                        key: 'goalKeeperCoach',
                        label: '守门员教练',
                        list: []
                    },
                    {
                        key: 'teamManager',
                        label: '球队经理',
                        list: []
                    },
                    {
                        key: 'doctor',
                        label: '队医',
                        list: []
                    }, {
                        key: 'interpretor',
                        label: '翻译',
                        list: []
                    }
                ],
                scrollDomHeight: 0,
                time: null,
            }
        },
        watch: {
            teamId: {
                handler(val, old) {
                    if (val != old) {
                        this.teamName = this.$store.state.teamName.split('_')[0];//梯队名称
                        this.info()
                    }
                },
                deep: true
            }
        },
        mounted() {
            this.info();
        },
        methods: {
            info() {
                let data = {
                    teamId: this.teamId,
                    // teamId: '5fbb328e99853c35e99eb2cb'
                }
                this.teamReportFn(data);
            },
            teamReportFn(data) {
                this.$server.teamReport(data)
                    .then((res) => {
                        this.teamReport = res.data;

                        for (let i = 0; i < this.teamReport.staff.length; i++) {
                            for (let j = 0; j < this.coachList.length; j++) {
                                if (this.teamReport.staff[i].title == this.coachList[j].key) {
                                    this.coachList[j].list.push(this.teamReport.staff[i]);
                                }
                            }
                        }

                        // console.log(this.coachList)

                        let setTime = setTimeout(() => {
                            const lookEl = document.querySelector('.main');
                            const el = document.querySelector('.contentBox');
                            this.scrollDomHeight = el.offsetHeight - lookEl.offsetHeight;
                            console.log(this.scrollDomHeight);
                            if (this.scrollDomHeight > 0) {
                                setTimeout(() => {
                                    this.scroll();
                                    clearInterval(this.time)
                                    this.time = setInterval(this.scroll, 10500);
                                }, 5000)
                            }
                            clearTimeout(setTime)
                        }, 100)
                    })
            },
            //滚动数据
            scroll() {
                const el = document.querySelector('.contentBox');
                let style = el.getAttribute('style')
                if (style && style == 'margin-top:' + -(this.scrollDomHeight) + 'px') {
                    el.setAttribute('style', 'margin-top:' + 0 + 'px')
                } else {
                    el.setAttribute('style', 'margin-top:' + -(this.scrollDomHeight) + 'px')
                }
            }
        },
        beforeDestroy() {
            clearInterval(this.time)
        }
    }
</script>

<style scoped lang="less">
    .cardTit {
        background-image: url("../assets/img/updateImg/head_2.png");
        font-size: 30px;
        box-sizing: border-box;
        position: relative;
        margin-top: 1vw;
    }

    .cardBg {
        text-align: center;
        max-height: calc(100% - 140px);
        padding-left: 2.5vw;
        box-sizing: border-box;
        overflow: hidden;
        /*overflow-y: scroll;*/

        .contentBox {
            height: 100%;
            overflow-y: scroll;
            transition: all 10s linear;
        }

        em {
            img {
                width: 100%;
            }
        }

        .title {
            clear: both;
            font-family: PingFangMedium;
            font-size: 28px;
            color: #fff;
            text-align: left;
            padding-top: 2.5vw;
            padding-bottom: 1vw;

            span {
                font-family: akrobatBold;
                font-size: 50px;
            }
        }

        .playerItem {
            background-image: url("../assets/img/teams/playerPositionbg.svg");
            background-size: 100%;
            background-repeat: no-repeat;
            width: 16%;
            float: left;
            height: 11vw;
            margin-right: 2%;

            .label {
                color: rgba(255, 255, 255, .9);
                font-size: 26px;
                margin-top: .8vw;
            }

            .num {
                font-family: akrobatBold;
                font-size: 50px;
                color: #fff;
                margin-top: 2vw;
            }
        }

        .statistics {
            font-family: PingFangMedium;
            width: calc((100% - (1.8vw * 3)) / 3);
            float: left;
            border: 1px solid rgba(255, 255, 255, .2);
            box-sizing: border-box;
            color: rgba(255, 255, 255, .6);
            font-size: 28px;
            position: relative;
            padding-left: 4vw;
            text-align: left;
            padding-top: 1vw;
            margin-bottom: 1.5vw;
            padding-bottom: .5vw;
            margin-right: 1.5vw;

            .icon {
                position: absolute;
                left: 1.5vw;
                top: 1.1vw;

                img {
                    width: 1.5vw;
                }
            }

            .num {
                font-size: 24px;

                span {
                    font-family: akrobatBold;
                    font-size: 42px;
                    color: #fff;
                }
            }
        }
    }
</style>
